import { DataGrid, gridClasses, GridColDef } from '@mui/x-data-grid';
import { dateFormatter } from '../../../../../../utils/timeFormat';
import { isDefaultDate } from '../../../../../../utils/common';
import { RootState } from '../../../../../../reducers';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../store/store';
import { clearSelections, getMIHAAlerts, getTopThreeMatches, setRowSelectionModel, setSelectedAlert, setUnmatchedId } from '../../../../../../store/hie.slice';
import { isValid } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { useEffect, useState } from 'react';
import { toDate } from '../../../../../../utils/dateHelpers';
import { GridRowSelectionModel } from '@mui/x-data-grid';
const MIHAAlerts = () => {
    const dispatch = useAppDispatch();

    const { mihaAlerts, unmatchedId, showArchivedAlerts } = useSelector((state: RootState) => state.hie);
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
    const [alertsRowSelectionModel, setAlertsRowSelectionModel] = useState<GridRowSelectionModel>({
        type: 'include', // or 'exclude'
        ids: new Set([]), // Your initial row IDs
    });

    const columns: GridColDef[] = [
        {
            field: 'LastName',
            headerName: 'Last Name',
            minWidth: 160,
        },
        {
            field: 'FirstName',
            headerName: 'First Name',
            minWidth: 160,
        },
        {
            field: 'DOB',
            headerName: 'DOB',
            minWidth: 140,
        },
        {
            field: 'CHPDownloadDate',
            headerName: 'Download Date',
            minWidth: 140,
            valueGetter: (value, row) => `${isDefaultDate(row.CHPDownloadDate) ? '-' : dateFormatter(new Date(row.CHPDownloadDate))}`,
        },
        {
            field: 'SendingFacility',
            headerName: 'Sending Facility',
            minWidth: 200,
        },
        {
            field: 'VisitType',
            headerName: 'Visit Type',
            minWidth: 100,
        },
        {
            field: 'AdmitDate',
            headerName: 'Admission Date',
            minWidth: 160,
            valueGetter: (value, row) => {
                const d = toDate(row.AdmitDate);
                return `${isDefaultDate(row.AdmitDate) ? '-' : isValid(d) ? formatInTimeZone(d, 'UTC', 'MM/dd/yyyy') : '-'}`;
            },
        },
        {
            field: 'AdmitTime',
            headerName: 'Admission Time',
            minWidth: 160,
            valueGetter: (value, row) => `${new Date(row.AdmitTime).toLocaleTimeString()}`,
        },
        {
            field: 'DischargeDate',
            headerName: 'Discharge Date',
            minWidth: 160,
            valueGetter: (value, row) => {
                const d = toDate(row.DischargeDate);
                return `${isDefaultDate(row.DischargeDate) ? '-' : isValid(d) ? formatInTimeZone(d, 'UTC', 'MM/dd/yyyy') : '-'}`;
            },
        },
        {
            field: 'DischargeTime',
            headerName: 'Discharge Time',
            minWidth: 160,
            valueGetter: (value, row) => `${row.DischargeTime ? new Date(row.DischargeTime).toLocaleTimeString() : '-'}`,
        },
    ];

    useEffect(() => {
        dispatch(getMIHAAlerts());
    }, [dispatch]);

    return (
        <>
            <DataGrid
                onRowClick={(params: any) => {
                    const { DOB, Id, LastName, FirstName } = params.row;
                    dispatch(clearSelections());
                    dispatch(setUnmatchedId(Id));
                    dispatch(setSelectedAlert(params.row));
                    dispatch(getTopThreeMatches(FirstName, LastName, DOB));
                }}
                autoHeight
                rows={showArchivedAlerts ? mihaAlerts : mihaAlerts.filter((alert) => alert.Archived !== true)}
                columns={columns}
                checkboxSelection={unmatchedId.length > 0 ? true : false}
                disableRowSelectionExcludeModel
                onRowSelectionModelChange={(newSelectionModel) => {
                    setAlertsRowSelectionModel(newSelectionModel);
                    const rowIds = Array.from(newSelectionModel.ids) || [];
                    dispatch(setRowSelectionModel(rowIds));
                }}
                rowSelectionModel={alertsRowSelectionModel}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                getRowHeight={() => 'auto'}
                pageSizeOptions={[5]}
                getRowId={(row) => row.Id}
                getRowClassName={(params) => (params.row.Archived ? 'archived' : '')}
                sx={{
                    [`& .${gridClasses.cell}`]: {
                        py: 1,
                    },
                    [`& .archived`]: {
                        background: 'rgba(200,200,200,0.4)',
                        fontStyle: 'italic',
                    },
                }}
            />
        </>
    );
};

export default MIHAAlerts;
